var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "solid",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 396.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.32,254.93c-3.26,3.29-5.36,7.56-5.97,12.16l-15.15,105.39c-1.57,12.57,6.19,24.32,24.32,24.32l105.39-15.15c4.6-.61,8.87-2.71,12.16-5.97l140.16-140.16-120.75-120.75L72.32,254.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M242.99,84.69l120.32,120.32c13.41-15.44,20.76-35.23,20.69-55.68-.47-47.34-39.23-85.33-86.57-84.86-19.95,.2-39.2,7.35-54.45,20.22h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.33,42.67H213.33c11.78,0,21.33-9.55,21.33-21.33S225.12,0,213.33,0H21.33C9.55,0,0,9.55,0,21.33s9.55,21.33,21.33,21.33Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.33,128H149.33c11.78,0,21.33-9.55,21.33-21.33s-9.55-21.33-21.33-21.33H21.33c-11.78,0-21.33,9.55-21.33,21.33s9.55,21.33,21.33,21.33Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64,170.67H21.33c-11.78,0-21.33,9.55-21.33,21.33s9.55,21.33,21.33,21.33h42.67c11.78,0,21.33-9.55,21.33-21.33s-9.55-21.33-21.33-21.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDraft);
export default __webpack_public_path__ + "static/media/icon-draft.0905dd223e6ad86de5c57276a8bd7d84.svg";
export { ForwardRef as ReactComponent };